import About1 from "../Components/About/About1";
import Blog1 from "../Components/Blog/Blog1";
import Brand1 from "../Components/Brand/Brand1";
import Choose1 from "../Components/Choose/Choose1";
import Counter1 from "../Components/Counter/Counter1";
import Cta1 from "../Components/Cta/Cta1";
import Faq1 from "../Components/Faq/Faq1";
import Feature1 from "../Components/Feature/Feature1";
import Feature2 from "../Components/Feature/Feature2";
import HeroBanner1 from "../Components/HeroBanner/HeroBanner1";
import HowWork from "../Components/HowWork/HowWork";
import Pricing1 from "../Components/Pricing/Pricing1";
import Testimonial from "../Components/Testimonial/Testimonial";

const Home = () => {
    return (
        <div>
            <HeroBanner1
                subtitle="<span>Pronto pra Vender?</span>#souhubgate"
                title="Escale sem travas. Saque com liberdade."
                content="Com a HubGate, você vai além do básico. Nossa tecnologia foi pensada para infoprodutores e afiliados que querem vender com agilidade, escalar com segurança e ter tudo centralizado em um único lugar."
                FeatureList={[
                    "Taxa D0 real, com liberação instantânea",
                    "Liberdade para escalar com segurança",
                    
                ]}   
                btnname="Criar Conta Agora"
                btnurl="https://app.hubgate.com.br/register"
                btntwo="Fale com um Gerente"
                btn2url="https://app.hubgate.com.br/register"
                cusimg="/assets/images/intro/introProfileThumb1_1.png"
                cusnumber="2,291"
                cuscontent="Avaliações"
                rating="4.8/5"
                ratingcon="Estrelas"
                img="/assets/images/intro/home.png"
            ></HeroBanner1>
            
            <About1
                img1="/assets/images/about/aboutThumb1_1.png"
                img2="/assets/images/about/aboutThumb1_2.png"
                subtitle="Sobre a HubGate"
                title="O gateway que entende o seu negócio."
                content="A maioria dos gateways limita o seu crescimento. Com a HubGate, você tem tecnologia de ponta, liberdade para escalar e controle total sobre seu funil. Desde o primeiro acesso até o saque, tudo é fluido e seguro."
                FeatureList={[
                    "Checkout com Quiz Builder nativo",
                    "KYC automatizado e onboarding fluido",
                    "Aprovação instantânea de pagamentos",
                    "Integração com plataformas de vendas",
                    "Liberdade para criar, testar e escalar",
                    
                ]}                
                btnname="Quero Testar a HubGate"
                btnurl="https://app.hubgate.com.br/register"
            ></About1>
            <HowWork></HowWork>
            <Choose1
                subtitle="App Advantage"
                title="Muito mais que um gateway. A solução completa para suas vendas online."
                content="Com a HubGate, você vai além do básico. Nossa tecnologia foi pensada para infoprodutores e afiliados que querem vender com agilidade, escalar com segurança e controlar o funil de conversão de ponta a ponta."
                // FeatureList={[
                //     "Saques Instantâneos",
                //     "Dados em Tempo Real",
                // ]} 
                // FeatureList2={[
                //     "Confiança e Performance",
                //     "Funis Integrados e otimizados em tempo real",
                // ]}                 
                btnname="Descubra como funciona "
                btnurl="https://app.hubgate.com.br/register"
            ></Choose1>
            <Feature1></Feature1>
            <Counter1></Counter1>
            <Faq1></Faq1>
            
            <Testimonial></Testimonial>
            <Feature2></Feature2>
            <Pricing1></Pricing1>
            <Cta1
                
                title="Baixe o App e Comece a Escalar com Liberação Instantânea!"
                content="Com a HubGate, você tem controle total sobre vendas, saques e verificação dos seus usuários — tudo na palma da mão. Baixe o app e comece a faturar sem travas, sem intermediários e com saque instantâneo."
                btnurl1="https://play.google.com/store"
                btnurl2="https://www.apple.com/store"
                img="/assets/images/cta/ctaThumb1_1.png"
            ></Cta1>
            {/* <Blog1></Blog1> */}
        </div>
    );
};

export default Home;